<template>

  <div class="full-screen" style="z-index: 7;">
    <top id="top-nav" title="视频详情" :detailType="datailType"></top>

    <div class="vod-main">

      <div class="vod-player">

        <div class="player-pic" v-if="showPic"></div>
        <div style="height: 10.7rem;" v-show="!showPic && !vodEnd">
          <div id="player" ref="playerDiv" class="prism-player" style="overflow: hidden !important;">
            <div class="mosaic" v-if="showText" @click="hidePlayerText()"><span>请不要相信视频中的各类广告链接</span></div>
          </div>
        </div>

        <div class="player_popeom" v-show="vodEnd">
          <p class="p1">{{ canTryWatchText }}</p>
          <p class="p2">完整观看需要{{vodPointsPlay}}金币购买</p>
          <p class="p4" v-if="vipFree">购买后永久观看，本视频VIP用户免费</p>
          <p class="p4" v-else>购买后即可永久观看，不重复扣费</p>
          <p class="p5">
            <a class="qrgm mscz" @click="toPurchase()">充值</a>
            <a class="qrgm " @click="buyVod()">{{ vodPointsPlay }}币购买</a>
          </p>
        </div>

      </div>
      <div class="vod-titile">
        {{ vodName }}
      </div>

      <div class="btnbox-bk" v-show="!vodEnd">
        <div class="col" v-if="!bought"><a class="btn btn-o" @click="buyVod()">购买本视频</a></div>
        <div class="col" v-else><a class="btn btn-o ccc">本视频已购买</a></div>
        <div class="col"><a class="btn btn-f" @click="toPurchase()">充值</a></div>
      </div>

    </div>

    <div class="more-list-title">更多精彩推荐</div>
    <vod-list :show-title="false" :vodData="guessLikeList"></vod-list>

    <div v-show="isLoading" class="loadingBox">加载中</div>
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>

    <div v-show="showAlertfull" class="alert-full">
      <div class="tx">
        <div>{{ alertMsg }}</div>
        <div v-if="alertAppBtn"><button class="btn" type="button" @click="downloadAndroidApp">点击下载App</button></div>
        <div v-if="alertHomeBtn"><button class="btn" type="button" @click="toHome">返回</button></div>
      </div>
    </div>

  </div>

</template>

<script>
import BookTop from '@/components/layer2/book/book-top'
import vodService from "../../../services/vodService";
import VodList from '@/components/share/vod-list.vue'
import userService from "../../../services/userService";
import Alert from '../../../components/share/alert';
import shelfService from "../../../services/shelfService";
import commService from "../../../services/commService";

export default {
  name: "vod-detail",
  data() {
    return {
      componentName: '',
      datailType: 'vod',
      userInfo:'',
      avaliableAmount: 0,
      vipType:false,
      vodId:'',
      vodName:'',
      vodPic:'',
      vodPlayUrl:'',
      vodPointsPlay:'',
      bought: false, //是否购买
      vipFree: false, //vip免费
      canTryWatch: true, //是否可以试看
      guessLikeList:[],
      exp: 15,
      showPic: true,
      showPopeom: false,
      isLoading: false,
      alertMsg: '',
      alertAppBtn: false,
      alertHomeBtn: false,
      showAlert: false,
      showAlertfull: false,
      vodEnd:false,
      player:null,
      playerStart: false,
      vodPlayFrom: '',
      showText: false,
      setIntervalFn: null,
      target: 1,
      canTryWatchText:'试看结束',
    }
  },
  watch: {
    '$route': 'gettingData'
  },
  methods: {
    hidePlayerText(){
      localStorage.setItem("PLAYER_TEXT", 'hide');
      this.showText = false
    },
    downloadAndroidApp() {
      window.location.href = commService.getLocalInitData().appDownloadUrl;
    },
    toHome() {
      this.$router.isBack = true;
      this.$router.push({path: '/vod'});
    },
    gettingData(){
      this.isLoading = true;
      this.vodId = this.$route.query.vodId
      vodService.getVodDetail(this.vodId)
        .then(res => {
          if (res.result) {
            this.bought = res.data.bought
            this.vipFree = res.data.vipFree
            this.canTryWatch = res.data.canTryWatch
            this.canTryWatchText = this.canTryWatch ? '试看结束': '本片无试看'
            this.guessLikeList = res.data.guessLikeList
            this.vodName = res.data.vodName
            this.vodPic = res.data.vodPic
            this.vodPlayUrl = res.data.vodPlayUrl
            this.vodPointsPlay = res.data.vodPointsPlay
            this.isLoading = false;
            this.showPic = false;
            this.vodPlayFrom = res.data.vodPlayFrom
            
            if(this.bought || this.vipFree){
              this.player = this.initPlayer(this.vodPlayUrl, null)
              this.showText = localStorage.getItem("PLAYER_TEXT") === 'hide' ? false : true;
            }else{
              //限制浏览器
              var userAgent = navigator.userAgent;
              if (userAgent.indexOf('QQBrowser') > -1) {
                  //不支持的浏览器
                  if (!!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                      //iOS
                      this.alertMsg = '暂不支持当前浏览器播放，请打开默认浏览器Safari观看';
                      this.showAlertfull = true;
                      this.alertHomeBtn = true
                  } else if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1) {
                      //安卓
                      this.alertMsg = '暂不支持当前浏览器播放，请使用手机默认浏览器或下载App观看'
                      this.alertAppBtn = true
                      this.alertHomeBtn = true
                      this.showAlertfull = true;
                  } else {
                      this.alertMsg = '暂不支持当前浏览器播放，推荐使用系统默认浏览器观看';
                      this.showAlertfull = true;
                      this.alertHomeBtn = true
                  }
                  return;
              }
              this.previewVod(this.stopWatch)
              if(this.canTryWatch){
                this.player = this.initPlayer(this.vodPlayUrl, this.exp)
                if(this.vodPlayFrom === '2088CDA55110450A03E1AFC297E82ECC'){
                  this.setIntervalFn = setInterval(() => {
                    // 获取当前已播放秒数
                    if(this.player && this.player.currentTime > 20){
                      this.showText = true
                      clearInterval(this.setIntervalFn)
                    }
                  }, 1000)
                }
              }
            }
          } else if (res.code === 101) {
            userService.getUserInfo();
            this.alertMsg = '网络拥堵，请重新加载本页面';
            this.showAlert = true;
          } else {
            this.alertMsg = '加载失败';
            this.showAlert = true;
          }
        })
    },
    //试看
    previewVod(fn){
      if (this.avaliableAmount >= this.vodPointsPlay || !this.canTryWatch) {
        //余额够买本视频
        this.stopWatch();
      } else {
        if (window.localStorage.getItem("w_" + this.vodId) === null) {
          window.localStorage.setItem("w_" + this.vodId, 1)
        }
        if (window.localStorage.getItem("w_" + this.vodId) < this.exp) {
          let setVid = "w_" + this.vodId
          let expMax = this.exp
          let interval = window.setInterval(() => {
            window.localStorage.setItem(setVid, parseInt(window.localStorage.getItem(setVid)) + 1)
            if (parseInt(window.localStorage.getItem(setVid)) >= expMax) {
              window.clearInterval(interval);
              fn()
            }
          }, 1000);
        } else {
          this.stopWatch()
        }
      }
    },

    //结束试看
    stopWatch(){
      this.vodEnd = true
      if (this.setIntervalFn) {
        clearInterval(this.setIntervalFn);
      }
      if (this.player) {
        // destroy()
        if (typeof this.player.destroy === 'function') {
          this.player.destroy();
        }
        this.player = null;
      }
      if (this.$refs.playerDiv) {
        this.$refs.playerDiv.remove();
      }
      this.showText = false
    },

    // 初始播放器
    initPlayer(source, exp) {
      if (!source) return null;
      // 西瓜播放器
      const PlayerClass = window.Player || window.Xgplayer;
      // HLS 插件
      const HlsPluginClass = window.HlsPlayer;
      if (!PlayerClass) {
        console.error("未成功加载，请检查");
        return null;
      }
      // 初始化播放器配置
      const playerConfig = {
        id: 'player',
        url: source,
        poster: this.vodPic || '',
        width: '100%',
        height: '100%',
        autoplay: true,
        autoplayMuted: false,
        videoInit: true,
        playsinline: true, 
        'x5-video-player-type': 'h5', // 优化微信/QQ浏览器播放
        fitVideoSize: 'auto',
        plugins: [HlsPluginClass]
      };
      const player = new PlayerClass(playerConfig);
      // 试看模式，添加控制逻辑
      if (exp !== null) {
        const expTime = parseInt(exp);
        // 使用 timeupdate 事件监听播放进度，一旦超过试看时长立即切断
        player.on('timeupdate', () => {
          if (player.currentTime >= expTime) {
            this.stopWatch();
          }
        });
      }
      return player;
    },

    toPurchase() {
      this.$router.isBack = true;
      this.$router.push({path: '/purchase'});
    },

    buyVod(){
      vodService.buyVod(this.vodId)
        .then(res => {
          if (res.code == 999) {
            this.alertMsg = res.msg;
            this.showAlert = true;
            setTimeout(() => {
              this.$router.isBack = true;
              this.$router.push({path: '/purchase'});
            }, 1000);
          }else if(res.code == 200){
            this.alertMsg = res.msg;
            this.showAlert = true;
            this.playerStart = true
            this.$router.go(0)
          }
        })
    },
    getVodlist(typeid,target) {
        vodService.getLatest(typeid,target)
          .then(res => {
            this.isLoading = false;
            if (res.data.totalPage === 0) {
              this.isNoMoreData = true;
              this.guessLikeList = []
            } else{
              this.guessLikeList = res.data.list;
            }
          })
    },
    addShelf() {
      this.addedToShelf = shelfService.addShelf(this.bookInfo);
    },

    isAddedToShelf() {
      let shelfBook = shelfService.getShelf().find(item => {
        return item.title === this.bookInfo.title
      });
      this.addedToShelf = !!shelfBook;
    },

  },
  components: {
    top: BookTop,
    'vod-list': VodList,
    alert: Alert,
  },
  mounted() {
    this.componentName = this.$route.path;
    userService.getUserOrReg().then(res => {
      this.avaliableAmount = res.avaliableAmount
      this.vipType = res.vipType === 'none' ? false : true
      this.gettingData();
    });

  },
  beforeDestroy(){
    this.vodEnd = true
    if (this.setIntervalFn) {
      clearInterval(this.setIntervalFn);
    }
    if (this.player) {
      if (typeof this.player.destroy === 'function') {
        this.player.destroy();
      }
      this.player = null;
    }
    if (this.$refs.playerDiv) {
      this.$refs.playerDiv.remove();
    }
    console.log('Exit play')
  },

}
</script>

<style scoped>
.vod-main{ padding-top: 2rem;}


.vod-player{ background: #000; padding:0; position: relative;min-height: 10.8rem !important; }
.vod-player .player-pic{ height: 10rem;
  background: #1a1a1a url(../../../assets/img/loading_ho2.jpg) center center no-repeat; background-size:40px;}
.prism-player{ height: 10.8rem !important;}
.vod-titile{ padding: .5rem .3rem;  line-height: 1rem; font-size: .8rem;}
.player-pic{height: 10.8rem;}
.player_popeom{width: 100%;text-align: center;position: absolute;top: 0; height: 10.7rem; left: 0; z-index: 99999; background: #000;}
.player_popeom a{display: inline-block;padding: 8px 20px;font-size: 16px;line-height: 20px;border-radius: 32px; color: #623A0C;  background: #E2C078;margin: 10px 5px;text-decoration: none;background-image: linear-gradient(-135deg, #FBE8A8 0%, #F8E7AC 15%, #E2C078 100%);}
.player_popeom p {line-height: 10px; font-size: .65rem; line-height: 1.2rem;  color: #fff; margin: 0; padding: 0;}
.player_popeom .p1 {font-size: .7rem; line-height: 1.7rem;  color: #fff; margin: 0; padding: 0; padding-top: 3.5rem;
  background: url(../../../assets/img/bg6.png) center .6rem no-repeat; background-size: 3rem auto;}
.player_popeom .p2{font-size: .5rem; line-height: 1.4rem; color: #999;}
.player_popeom .p4{ color: #ffe65c;line-height: 1rem;font-size: .6rem;}
.player_popeom .user-wbg {background: #fff;color: #333;}

.player_popeom .qrgm {background: linear-gradient(to right,#ffd879,#d9b24f);  border-radius: 8px;
  color: #6a2700;border: 0px solid #ffef97;vertical-align: middle;width: 5rem; line-height: 1rem; font-size: .7rem;
 }
.player_popeom .qrgm img {height: 20px;}


.player_popeom .mscz{background: none;border: 1px solid #ffd879; color: #ffd879;}
.player_popeom small {color: #999;}


.loadingBox{ position: fixed; top: calc(50% - 40px); left: calc(50% - 40px); width: 80px; height: 80px; line-height: 140px; overflow: hidden;
  background: #000 url(../../../assets/img/loading.gif) center -20px no-repeat; background-size:110px ; color: #ccc; text-align: center; font-size: 12px; border-radius: 10px;}

.more-list-title{ height: 2rem; line-height: 2rem; font-size: .6rem; color: #fff; padding-left: 1.6rem; margin-top: .2rem; border-top: 1px solid #333;
  background: url(../../../assets/images/icon-h3-1.png) .4rem center no-repeat; background-size: 0.8rem; }
.topbar{background: linear-gradient(to right,#000,#333) !important; height: 2rem !important;}
.span-title .f14{line-height: .8rem !important; font-size: .7rem !important; opacity: .8rem;}
.btnbox-bk .col .btn.ccc{border-color: #ccc;color: #ccc;border: 0.1rem solid #ccc; background: none;}

</style>
<style>.preview-vod-component .preview-component-tip{ bottom: 10px !important; font-size: .55rem; left: 10% !important; right: 10% !important; text-align: center;}</style>



// WEBPACK FOOTER //
// src/pages/layer2/vod/detail.vue